import FormDadosCooperativa from "./FormularioPeriodo";
import FormDadosJornada from "../../jornada/FomularioPeriodo";
import FormDadosPufv from "../../uniao/FormularioPeriodo";

export type FormularioPeriodoHandle = {
  submitForm: () => void;
};

export type FormularioPeriodoProps = {
  id: string;
  periodo: string;
  idPeriodo?: string
};

export const FormDadosCooperativaTyped = FormDadosCooperativa as React.ForwardRefExoticComponent<
  FormularioPeriodoProps & React.RefAttributes<FormularioPeriodoHandle>
>;

export const FormDadosPufvTyped = FormDadosPufv as React.ForwardRefExoticComponent<
  FormularioPeriodoProps & React.RefAttributes<FormularioPeriodoHandle>
>;

export const FormDadosJornadaEducacaoTyped = FormDadosJornada as React.ForwardRefExoticComponent<
  FormularioPeriodoProps & React.RefAttributes<FormularioPeriodoHandle>
>;


